/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDurationUnitResource } from './';
import {
    ProjectDurationUnitResourceFromJSON,
    ProjectDurationUnitResourceFromJSONTyped,
    ProjectDurationUnitResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDurationChoiceRequest
 */
export interface ProjectDurationChoiceRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectDurationChoiceRequest
     */
    amount: number;
    /**
     * 
     * @type {ProjectDurationUnitResource}
     * @memberof ProjectDurationChoiceRequest
     */
    unit: ProjectDurationUnitResource;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDurationChoiceRequest
     */
    fixed: boolean;
}

/**
 * Check if a given object implements the ProjectDurationChoiceRequest interface.
 */
export function instanceOfProjectDurationChoiceRequest(value: object): value is ProjectDurationChoiceRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('fixed' in value) || value['fixed'] === undefined) return false;
    return true;
}

export function ProjectDurationChoiceRequestFromJSON(json: any): ProjectDurationChoiceRequest {
    return ProjectDurationChoiceRequestFromJSONTyped(json, false);
}

export function ProjectDurationChoiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDurationChoiceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'unit': ProjectDurationUnitResourceFromJSON(json['unit']),
        'fixed': json['fixed'],
    };
}

export function ProjectDurationChoiceRequestToJSON(value?: ProjectDurationChoiceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'unit': ProjectDurationUnitResourceToJSON(value['unit']),
        'fixed': value['fixed'],
    };
}

